import React from 'react';

function Contact() {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Contact</h1>
      <p>If you have any questions or suggestions, feel free to reach out!</p>
      <p>Email: contact@wanna.coffee</p>
    </div>
  );
}

export default Contact;